module.exports = __webpack_public_path__ + "static/video-making-poster-e44b04c6525da23b1558d04b2097bb18.jpg";